import { render, staticRenderFns } from "./MyWishlist.vue?vue&type=template&id=3f3530b8&"
import script from "./MyWishlist.vue?vue&type=script&lang=js&"
export * from "./MyWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports